import React, { useContext, useLayoutEffect, useRef } from 'react';
import { GridEditInputCell } from '@mui/x-data-grid';

const CaretIntentContext = React.createContext(null);

export const CaretIntentProvider = CaretIntentContext.Provider;

export const markSelectAll = (intentRef, id, field) => {
  if (!intentRef || field === 'result') return;
  intentRef.current = { id, field, selectAll: true };
};

export const markClickOffset = (intentRef, id, field, x, y) => {
  if (!intentRef || field === 'result') return;
  intentRef.current = { id, field, selectAll: false, offset: offsetFromPoint(x, y) };
};

const offsetFromPoint = (x, y) => {
  const range = document.caretRangeFromPoint?.(x, y)
    || caretRangeFromPosition(document.caretPositionFromPoint?.(x, y));
  if (!range || range.startContainer?.nodeType !== Node.TEXT_NODE) return null;
  return range.startOffset;
};

const caretRangeFromPosition = (position) => {
  if (!position) return null;
  return { startContainer: position.offsetNode, startOffset: position.offset };
};

const applyCaretIntent = (intentRef, id, field, input) => {
  const pending = intentRef?.current;
  if (!pending || String(pending.id) !== String(id) || pending.field !== field) return;
  intentRef.current = null;
  const length = input.value == null ? 0 : String(input.value).length;
  if (pending.selectAll) {
    input.setSelectionRange(0, length);
    return;
  }
  const offset = pending.offset == null ? length : Math.min(Math.max(pending.offset, 0), length);
  input.setSelectionRange(offset, offset);
};

export const ComparisonTextEditCell = (props) => {
  const rootRef = useRef(null);
  const intentRef = useContext(CaretIntentContext);

  useLayoutEffect(() => {
    if (!props.hasFocus) return;
    const input = rootRef.current?.querySelector('input, textarea');
    if (!input) return;
    applyCaretIntent(intentRef, props.id, props.field, input);
  }, [props.hasFocus, props.id, props.field, intentRef]);

  return (
    <div ref={rootRef} style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
      <GridEditInputCell
        {...props}
        style={{
          width: '100%',
          height: '100%',
          fontSize: 'inherit',
          lineHeight: '34px',
          padding: 0,
        }}
        inputProps={{
          style: {
            height: '100%',
            padding: '0 10px',
            lineHeight: '34px',
            boxSizing: 'border-box',
          },
        }}
      />
    </div>
  );
};

export const renderComparisonTextEditCell = (params) => <ComparisonTextEditCell {...params} />;
